<template>
    <component :is="addressComponent"></component>
</template>

<script>
import ModalChangeAddressDefaultComponent from './ModalChangeAddressDefaultComponent.vue';
import ModalChangeAddressUsComponent from './ModalChangeAddressUsComponent.vue';

export default {
    name: 'ModalChangeAddress',
    components: {
        ModalChangeAddressDefaultComponent,
        ModalChangeAddressUsComponent
    },
    data() {
        return {
            data: '',
        }
    },
    computed: {
        addressComponent() {
            switch(this.$root.whitelabel.setting('wlCountry')) {
                case 'us':
                    return 'modal-change-address-us-component'
                    break;
                default:
                    return 'modal-change-address-default-component'
            } 
        }
    }
}
</script>
